import { Component, Injectable, NgZone } from '@angular/core';
import { Subject, Observable, Subscription, fromEvent, map } from 'rxjs';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { LoginService } from '../login/login.service';
import * as _ from 'lodash';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserActivitiesService {

  private intervalId: any;
  private currentPath: string = '';
  private currentQueryParams: any = {};

  userInactive: Subject < boolean > = new Subject();
  isInternetServiceAvailable: Subject < boolean > = new Subject();
  isCurrentLoggedInBrandIdChanged: Subject < boolean > = new Subject();
  constructor(private router: Router, private ngZone: NgZone, private loginService: LoginService, private __helpers: HelpersService, private activatedRoute: ActivatedRoute) {
    this.monitorRouteChanges();
    this.setupVisibilityChangeHandler();
    this.initListener();
  }

  initListener() {
    // window.addEventListener('mousemove', () => this.reset());
    // window.addEventListener('click', () => this.reset());
    // window.addEventListener('keypress', () => this.reset());
    // window.addEventListener('DOMMouseScroll', () => this.reset());
    // window.addEventListener('mousewheel', () => this.reset());
    // window.addEventListener('touchmove', () => this.reset());
    // window.addEventListener('MSPointerMove', () => this.reset());
    window.addEventListener('online', () => this.isInternetConnectionAvailable(true));
    window.addEventListener('offline', () => this.isInternetConnectionAvailable(false));
  }


  // #TODO Call API or Action Here.
  private callApi(event: string) {
    // console.log(`Calling API due to: ${event}`);
    this.updateManagerDetails();
    this.userInactive.next(true);
  }

  // Moniot Routing changes 
  private monitorRouteChanges() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      const tree = this.router.parseUrl(this.router.url);
      this.currentQueryParams = tree.queryParams;
      const path = this.router.url.toLowerCase();
      this.currentPath = path;
      if (this.pathIsProjectOrAccount(path)) {
        this.startInterval();
      } else {
        this.stopInterval();
      }
    });
  }

  // Action on Projec and account level routing
  private pathIsProjectOrAccount(path: string): boolean {
    return path.includes('/accounts') || path.includes('/project') || path.includes('/adminconsole') || path.includes('/billing');
  }

  //  Timer for Call Update logut API 
  private startInterval() {
    if (this.intervalId) return; // Already running

    this.ngZone.runOutsideAngular(() => {
      this.intervalId = setInterval(() => {
        if (this.pathIsProjectOrAccount(this.currentPath) && document.visibilityState === 'visible') {
          this.callApi('interval');
        }
      }, 3 * 60 * 1000); // 3 minutes
    });
  }

  private stopInterval() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  // If Tab is Active/Inactive
  private setupVisibilityChangeHandler() {
    document.addEventListener('visibilitychange', () => {
      if (this.pathIsProjectOrAccount(this.currentPath) && document.visibilityState === 'visible') {
        this.callApi('interval');
      }
    });
  }

  // Check Internet Connection Available
  isInternetConnectionAvailable(status) {
    this.isInternetServiceAvailable.next(status);
  }

  // Get real-time query parameters
  getCurrentQueryParams(): any {
    return this.activatedRoute.snapshot.queryParams;
  }

  // Get real-time query parameters as observable (for reactive updates)
  getCurrentQueryParamsObservable(): Observable<any> {
    return this.activatedRoute.queryParams;
  }


  // If curent logged in Brand details changed, update Helpers 
  updateManagerDetails() {
    this.loginService.checkUserIsLoggedIn().subscribe((response: any) => {
      const currentLoggedInBrandId = _.get(response, 'data.loggedInManager.brand_id', null);
      const isManagerLoggedIn = _.get(response, 'data.isManagerLoggedIn', false);
      if (isManagerLoggedIn == true) {
        // Get real-time query parameters
        const realTimeQueryParams = this.getCurrentQueryParams();
        if (realTimeQueryParams['project_id'] !== currentLoggedInBrandId) {
          this.__helpers.helpers['managerDetails'] = response.data;
          window['Helpers'] = this.__helpers.consoleData();
          this.isCurrentLoggedInBrandIdChanged.next(true);
        } else {
          this.isCurrentLoggedInBrandIdChanged.next(false);
        }
      }
    })
  }


}
